import { TextField } from "@mui/material";
import React from "react";
import { AppointmentOverviewContext } from "../context/appointmentOverviewContext";
import SearchControllsProps from "../interface/searchControllsProps";

const FromTimeInput = (): React.JSX.Element => {
  const {
    searchControlls,
    setSearchControlls,
  }: {
    searchControlls: SearchControllsProps;
    setSearchControlls: React.Dispatch<
      React.SetStateAction<SearchControllsProps>
    >;
  } = React.useContext(AppointmentOverviewContext);

  const handleSetFromDate = (date: string): void => {
    setSearchControlls({
      ...searchControlls,
      date: { ...searchControlls.date, start: date },
    });
  };

  return (
    <TextField
      disabled={searchControlls.loading}
      fullWidth
      type="date"
      value={searchControlls.date.start}
      onChange={(e: any) => handleSetFromDate(e.target.value)}
      id="StartOfQualification"
      label="Termin von"
      variant="outlined"
    />
  );
};

export default FromTimeInput;
